import { render, staticRenderFns } from "./MailConfigSetting.vue?vue&type=template&id=3b0bfb9e&"
import script from "./MailConfigSetting.vue?vue&type=script&lang=js&"
export * from "./MailConfigSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0bfb9e')) {
      api.createRecord('3b0bfb9e', component.options)
    } else {
      api.reload('3b0bfb9e', component.options)
    }
    module.hot.accept("./MailConfigSetting.vue?vue&type=template&id=3b0bfb9e&", function () {
      api.rerender('3b0bfb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/MailConfigSetting.vue"
export default component.exports